export const declension = (
  number: number,
  title: [string, string, string]
): string => {
  const n = Math.abs(number) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) {
    return title[2];
  }
  if (n1 > 1 && n1 < 5) {
    return title[1];
  }
  if (n1 === 1) {
    return title[0];
  }
  return title[2];
};

export const addZero = (number: string): string =>
  number.toString().length < 2 ? `0${number}` : number;

export const createArticle = <T>(id: T): T => id;
// return id.toString().padStart(max, '0');

export const slidesToShow = <T>(items: T[], max: number): number =>
  items.length > max ? max : items.length;

export const menuTreeDevice = (): 'mobile' | 'desktop' => {
  if (window.innerWidth < 1280) {
    return 'mobile';
  } else {
    return 'desktop';
  }
};

export const numberTextFormat = (num: number, digits = 0): [string, string] => {
  const si = [
    {
      value: 1,
      symbol: declension(num, ['раз', 'раза', 'раз'])
    },
    {
      value: 1e3,
      symbol: 'тыс. раз'
    },
    {
      value: 1e6,
      symbol: 'млн. раз'
    },
    {
      value: 1e9,
      symbol: 'млрд. раз'
    },
    {
      value: 1e12,
      symbol: 'трлн. раз'
    },
    {
      value: 1e15,
      symbol: 'P'
    },
    {
      value: 1e18,
      symbol: 'E'
    }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  let i;

  for (i = si.length - 1; i > 0; i--) {
    if (num >= si[i].value) {
      break;
    }
  }

  return [(num / si[i].value).toFixed(digits).replace(rx, '$1'), si[i].symbol];
};
